import React from 'react';
import { styled } from '@linaria/react';
import queryString from 'query-string';
import sanitizeHtml from 'sanitize-html';

import { Status } from '@blocks/constants';
import { ModalRef } from '@blocks/ui/modal';
import { isBrowser } from '@blocks/utils';

import { Button, Modal } from '../../ui';

import CheckIcon from './CheckOutlined.inline.svg';
import { ECMIconContainer, ECMMessageText } from './ui';

import '../../styles/theme.css';

const EmailConfirmedParam = 'email-verification';

const CloseOAuth2ErrorModalButton = styled(Button)`
  margin-top: 16px;
`;

const getMessageString = (message: string | (string | null)[] | null): string => {
  if (Array.isArray(message)) {
    return message.filter(Boolean).join(' ');
  }

  if (!message) {
    return 'Some error occurred. Please try again later or contact support.';
  }

  return message;
};

const removeDataFromUrl = () => {
  if (isBrowser()) {
    const url = new URL(window.location.href);
    url.searchParams.delete('email-verification');
    window.history.replaceState({}, document.title, url.toString());
  }
};

const EmailConfirmationModal = () => {
  const messageModal = React.useRef<ModalRef>(null);
  const defaultMessage = 'Your email has been verified';
  const [errorMessage, setErrorMessage] = React.useState<string>('');

  React.useEffect(() => {
    if (isBrowser()) {
      const { message, ...rest } = queryString.parse(window.location.search);
      const emailVerification = rest[EmailConfirmedParam];

      if (emailVerification === Status.ok || emailVerification === Status.error) {
        messageModal.current?.open();
      }

      if (rest[EmailConfirmedParam] === Status.error) {
        setErrorMessage(sanitizeHtml(getMessageString(message)));
      }
    }
  }, []);

  return (
    <Modal
      ref={messageModal}
      title={null}
      afterClose={removeDataFromUrl}
    >
      {!errorMessage && (
        <ECMIconContainer>
          <CheckIcon />
        </ECMIconContainer>
      )}
      <ECMMessageText>{errorMessage ? errorMessage : defaultMessage}</ECMMessageText>
      <CloseOAuth2ErrorModalButton
        onClick={() => {
          messageModal.current?.close();
        }}
      >
        Continue
      </CloseOAuth2ErrorModalButton>
    </Modal>
  );
};

export default EmailConfirmationModal;
